import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn } from "../../../utils";
import { useInsideDialog } from "../dialog/dialog";
function Popover({ modal, ...props }) {
    // Mirror Combobox/Select: a popover inside a Dialog defaults to modal so its own
    // focus/scroll lock governs it. Otherwise a focus-grabbing child (a nested
    // Combobox/Select) trips this non-modal layer's focus-outside dismissal and
    // collapses it. Explicit `modal` wins — pass modal={false} to opt a specific
    // in-dialog popover back out.
    const insideDialog = useInsideDialog();
    return /*#__PURE__*/ _jsx(PopoverPrimitive.Root, {
        modal: modal ?? insideDialog,
        ...props
    });
}
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = /*#__PURE__*/ React.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref)=>/*#__PURE__*/ _jsx(PopoverPrimitive.Portal, {
        children: /*#__PURE__*/ _jsx(PopoverPrimitive.Content, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: cn("z-(--z-popover) w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-(--radix-popover-content-transform-origin)", className),
            ...props
        })
    }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent };

//# sourceMappingURL=popover.js.map